<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.task.field.id') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.id" :clearable="true" />
        </div>
      </div>
      <div class="filter__item col-3">
        <select-status v-model="form.state" />
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.task.field.priority') }}
        </label>
        <div class="filter__item__body">
          <input-number v-model="form.priority" :min="0" class="w-100" :clearable="true" />
        </div>
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.task.field.attempts') }}
        </label>
        <div class="filter__item__body">
          <input-number v-model="form.attempts" :min="0" class="w-100" :clearable="true" />
        </div>
      </div>
      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import SelectStatus from './task-filter-status';
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper,
      SelectStatus
    },
    data: () => ({
      numbers: [],
      form: {
        id: '',
        state: '',
        priority: null,
        attempts: null
      }
    }),

    methods: {
      ...mapActions('autocaller_v2/campaigns/tasks/table', ['search']),
      submit: function () {
        const { id, state, priority, attempts } = this.form;
        const params = {
          id,
          state,
          priority,
          attempts
        };
        this.search(params);
      }
    }
  };
</script>
